"use client";

import React from "react";

type OnclickButtonProps = {
	onClick: string;
	children: React.ReactNode;
	className?: string;
};

// Mapping of jsCode keys to JavaScript function calls
const jsCodeMapping: Record<string, () => void> = {
	// Navigation functions
	osanoShowDrawer: () =>
		window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open"),
};

const OnclickButton: React.FC<OnclickButtonProps> = ({
	onClick,
	children,
	className,
}) => {
	const handleClick = () => {
		// Extract the JavaScript code after "onclick:"
		const jsCode = onClick.split(":").slice(1).join(":");

		// Check if the jsCode exists in our mapping to prevent bad actors.
		if (jsCodeMapping[jsCode]) {
			jsCodeMapping[jsCode]();
		} else {
			return;
		}
	};

	return (
		<button onClick={handleClick} className={className}>
			{children}
		</button>
	);
};

export default OnclickButton;
